import { render, staticRenderFns } from "./CPTable.vue?vue&type=template&id=2ebaabbb&scoped=true"
import script from "./CPTable.vue?vue&type=script&lang=js"
export * from "./CPTable.vue?vue&type=script&lang=js"
import style0 from "./CPTable.vue?vue&type=style&index=0&id=2ebaabbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebaabbb",
  null
  
)

export default component.exports